/**
 * Constants for onboarding checklist functionality
 * These must match the backend constants exactly
 */

// Valid onboarding checklist item types
export const ONBOARDING_CHECKLIST_ITEM_TYPES = [
  'customize_branding',
  'create_journey', 
  'add_media',
  'view_insights',
  'invite_team'
] as const;

// Event type to checklist item type mapping
export const EVENT_TO_CHECKLIST_ITEM_MAPPING: Record<string, string> = {
  'onboarding:branding-customized': 'customize_branding',
  'onboarding:journey-created': 'create_journey',
  'onboarding:media-added': 'add_media',
  'onboarding:insights-viewed': 'view_insights',
  'onboarding:team-invited': 'invite_team',
};

// Type for checklist item types
export type OnboardingChecklistItemType = typeof ONBOARDING_CHECKLIST_ITEM_TYPES[number];

// Validate that all event types map to valid item types
export function validateEventMapping(): boolean {
  for (const eventType of Object.keys(EVENT_TO_CHECKLIST_ITEM_MAPPING)) {
    const itemType = EVENT_TO_CHECKLIST_ITEM_MAPPING[eventType];
    if (!ONBOARDING_CHECKLIST_ITEM_TYPES.includes(itemType as OnboardingChecklistItemType)) {
      console.error(`Event type ${eventType} maps to invalid item type ${itemType}`);
      return false;
    }
  }
  
  // Validate that all item types have corresponding events
  const mappedItemTypes = new Set(Object.values(EVENT_TO_CHECKLIST_ITEM_MAPPING));
  const allItemTypes = new Set(ONBOARDING_CHECKLIST_ITEM_TYPES);
  
  if (mappedItemTypes.size !== allItemTypes.size) {
    console.error('Event mapping count does not match item types count');
    return false;
  }
  
  for (const itemType of ONBOARDING_CHECKLIST_ITEM_TYPES) {
    if (!mappedItemTypes.has(itemType)) {
      console.error(`Missing event for item type: ${itemType}`);
      return false;
    }
  }
  
  return true;
}

// Validate on module import
if (!validateEventMapping()) {
  throw new Error('Onboarding checklist event mapping validation failed');
}
